import React from 'react'
import {Button, Icon, Tag} from 'antd'

import {invitesService} from 'services'
import useUserContext from 'components/User/useUserContext'
import requestHandler from 'utils/requestHandler'

export const HandleInviteButtons = ({inviteUuid, setInteracted}) => {
  const {user, setUser} = useUserContext()
  const [done, setDone] = React.useState(null)

  const handleInvite = accept => {
    setInteracted(true)
    setDone(undefined)
    const data = {
      uuid: inviteUuid,
      state: accept ? 'Accepted' : 'Declined',
    }

    requestHandler(() => invitesService.patchInvites(user.accountantProfile.uuid, inviteUuid, data, user.accessToken), 'json')
      .then(response => {
        if (response.success) {
          setUser(u => ({...u, notificationsCount: u.notificationsCount - 1}))
          setDone(accept)
        } else {
          setDone(null)
        }
      })
  }

  return (
    done === null ? (
      <Button.Group>
        <Button type='danger' icon='close' size='small' onClick={() => handleInvite(false)}/>
        <Button type='primary' icon='check' size='small' onClick={() => handleInvite(true)}/>
      </Button.Group>
    ) : done === undefined ? (
      <Icon type='loading'/>
    ) : done ? (
      <Tag color='green'>Accepted</Tag>
    ) : (
      <Tag color='red'>Declined</Tag>
    )
  )
}

export default HandleInviteButtons
